import React from "react";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";
// import get from "lodash/get";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { OffcanvasMenu } from "../../molecules/offcanvas-menu";
import "./navigation-links.m.css";
// import { isDesktopSizeViewport } from "../../../utils";

export class NavigationLinks extends React.Component {
  constructor() {
    super();
    this.state = {
      enabledSubmenuId: null
    };
  }

  toggleChildMenu(itemId) {
    if (this.state.enabledSubmenuId === itemId) {
      this.setState({
        enabledSubmenuId: null
      });
    } else {
      this.setState({
        enabledSubmenuId: itemId
      });
    }
  }

  closeChildMenu() {
    this.setState({
      enabledSubmenuId: null
    });
  }

  getClass(itemId) {
    if (itemId === this.state.enabledSubmenuId) {
      return "is-open";
    }
    return "";
  }

  render() {
    const menus = this.props.links.slice(0, 9);
    const restMenus = this.props.links.slice(9);
    return (
      <OffcanvasMenu
        showOffcanvasMenu={this.props.showOffcanvasMenu}
        closeMenu={this.props.closeMenu}
      >
        <ul styleName="navigation-links">
          {menus &&
            menus.map((item, index) => {
              if (item.children.length) {
                return (
                  <li styleName="item item--have-child" key={item.id}>
                    <div
                      styleName="link link--sm"
                      onClick={() => this.toggleChildMenu(item.id)}
                    >
                      {item.title}
                      <div className="navigation-links__link-icon">
                        {item.id === this.state.enabledSubmenuId ? (
                          <FaChevronUp />
                        ) : (
                          <FaChevronDown />
                        )}
                      </div>
                    </div>
                    <Link href={item.completeUrl} styleName="link--lg">
                      {item.title}
                    </Link>
                    <ul
                      styleName={`navigation-submenu ${this.getClass(item.id)}`}
                    >
                      {item.children.map(child => {
                        return <SubmenuItem item={child} key={child.url} />;
                      })}
                    </ul>
                  </li>
                );
              }
              return (
                <li key={index} styleName="item">
                  {item.title !== "Store" ? (
                    <Link style={{ display: "block" }} styleName="link-style" href={item.completeUrl}>
                      {item.title}
                    </Link>
                  ) : (
                    <Link
                      style={{ display: "block" }}
                      styleName="link-style"
                      href={item.completeUrl}
                      target="_blank"
                    >
                      {item.title} <small styleName="new-banner">NEW</small>
                    </Link>
                  )}
                </li>
              );
            })}
          {this.props.links && this.props.links.length > 9 ? (
            <li styleName="item item--have-child display-desktop-only">
              {this.props.domainSlug ? "और पढ़ें" : "More"}
              <ul styleName={`navigation-submenu`}>
                {this.props.links &&
                  this.props.links.slice(9).map((item, index) => {
                    return <SubmenuItem item={item} key={item.completeUrl} />;
                  })}
              </ul>
            </li>
          ) : null}

          {this.props.links && this.props.links.length > 9
            ? restMenus.map((item, index) => {
                return (
                  <li key={index} styleName="item display-mobile-only">
                    <Link styleName="link-style" href={item.completeUrl}>
                      {item.title}
                    </Link>
                  </li>
                );
              })
            : null}
        </ul>
      </OffcanvasMenu>
    );
  }
}

NavigationLinks.propTypes = {
  links: PropTypes.array,
  closeOffcanvasMenu: PropTypes.func,
  showOffcanvasMenu: PropTypes.bool,
  closeMenu: PropTypes.func,
  domainSlug: PropTypes.string
};

function SubmenuItem(props) {
  return (
    <li styleName="submenu-item">
      <Link
        styleName="link-desktop-style"
        href={
          props.item["parent-slug"]
            ? props.item["parent-slug"] + props.item.completeUrl
            : props.item.completeUrl
        }
      >
        {props.item.title}
      </Link>
    </li>
  );
}

SubmenuItem.propTypes = {
  item: PropTypes.shape({
    "parent-slug": PropTypes.string,
    completeUrl: PropTypes.string,
    title: PropTypes.string
  })
};
